import { defineStore } from 'pinia';

import { Result } from '@/classes/result';
import type { OrganizationEmployee } from '@/types/employee';
import type { UpsertOrganizationEmployeesRequest } from '@/types/requests/organizationEmployees/upsertOrganizationEmployeesRequest';
import { callApi } from '@/utils//api';
import { handleAxiosError } from '@/utils/error';

export const useOrganizationEmployeeStore = defineStore('organizationEmployees', () => {
    async function upsertMany(organizationId: string, request: UpsertOrganizationEmployeesRequest): Promise<Result> {
        try {
            const result = await callApi({
                method: 'PUT',
                endpoint: `organizationEmployees/${organizationId}`,
                body: request
            });

            return result;
        } catch (error) {
            return handleAxiosError(error, [], 'Kan medewerker(s) niet bijwerken.');
        }
    }

    async function getEmployeeInformationInOrganization(organizationId: string, employeeId: string): Promise<OrganizationEmployee> {
        try {
            const result = await callApi({
                method: 'GET',
                endpoint: `organizationEmployees/${organizationId}/employees/${employeeId}`
            });

            return result.object;
        } catch (error) {
            return handleAxiosError(error, [], 'Kon medewerker informatie niet ophalen');
        }
    }

    return {
        upsertMany,
        getEmployeeInformationInOrganization
    };
});
